import axios from './axios'

function service(endpoint) {

    function fetchPromoList (data) {
        return axios.get(`${endpoint}/promo-list`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function fetchInstallationList (data) {
        return axios.get(`deployments/requiredSettings/modules`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function fetchInstalled (data) {
        return axios.get(`${endpoint}/installed`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function fetchInstallable (data) {
        return axios.get(`${endpoint}/installable`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function installModule(id, data = {}) {
        return axios.post(`${endpoint}/${id}/install`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function uninstallModule(id, data = {}) {
        return axios.post(`${endpoint}/${id}/uninstall`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function checkModuleStatus(id, data = {}) {
        return axios.get(`${endpoint}/${id}/status`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        fetchPromoList,
        fetchInstalled,
        fetchInstallable,
        installModule,
        uninstallModule,
        checkModuleStatus,
        fetchInstallationList
    }
}

export default service
